/**
 * Test-type image URLs for the Screenshots section on experience app detail pages.
 * Maps each assessment type to an image shown alongside the case study image.
 *
 * Add your 4 links for Logical, Verbal, Numerical, and Pattern Reasoning below.
 * Screenshots = 1 case image + 1 per test type the app has (from this config).
 * Scalable: add video_interview or new keys + app flags to support more types.
 */
export const TEST_IMAGE_URLS = {
  logical: 'https://pathbuddy-media.lon1.cdn.digitaloceanspaces.com/Apps/Logical_reasoning_SS2.png',   // Logical Reasoning test image URL
  verbal: 'https://pathbuddy-media.lon1.cdn.digitaloceanspaces.com/Apps/Verbal_reasoning_SS.png',    // Verbal Reasoning test image URL
  numerical: 'https://pathbuddy-media.lon1.cdn.digitaloceanspaces.com/Apps/Numerical_reasoning_SS.png', // Numerical Reasoning test image URL
  pattern: 'https://pathbuddy-media.lon1.cdn.digitaloceanspaces.com/Apps/Pattern_recognition_SS.png',   // Pattern Recognition test image URL
  video_interview: 'https://pathbuddy-media.lon1.cdn.digitaloceanspaces.com/Apps/Video_Interview_SS.png',  // optional – uncomment when you have a Video Interview image
};

/** Display order for test images (case image is always first, then these). */
export const TEST_IMAGE_ORDER = ['logical', 'pattern', 'numerical', 'verbal', 'video_interview'];
